import {Injectable} from '@angular/core';

@Injectable()
export class UiConfig {
  public static getConfig(): IUiConfig{
    const uiCfg = window['uiConfig']
    return uiCfg as IUiConfig
  }
}

export interface IUiConfig {
  uiLogsPageSize: number
}
